import React, { useState, useEffect } from 'react';
const awardDistributionImages = [
  { title: "Awards Distribution to Team WAdau AI ", image: "images/award1.jpg" },
  { title: "Awards Distribution to Team Pravaah AI", image: "images/award2.jpg" },
  { title: "Awards Distribution to Team Predictive Pulse", image: "images/award3.jpg" },
  { title: "Awards Distribution to Team WellEX", image: "images/award4.jpg" },
  { title: "Awards Distribution to Team Payzone AI", image: "images/award5.jpg" },
  { title: "Awards Distribution to Team Wellsti Wizards", image: "images/award6.jpg" },
  { title: "Awards Distribution to Team Wisdom", image: "images/award7.jpg" },
  { title: "Awards Distribution to Team Optiinject", image: "images/award8.jpg" },
  { title: "Awards Distribution to Team Drishti", image: "images/award9.jpg" },
  { title: "Awards Distribution to Team Profit Pro AI", image: "images/award10.jpg" },
  { title: "Awards Distribution to Team Crew Path Innovators", image: "images/awards11.jpg" }, 
  { title: "Awards Distribution to Team Paradigm Breaker Awards", image: "images/awards12.jpg" },
  { title: "Awards Distribution to Team Inv _ Optima", image: "images/awards13.jpg" },  
];


// Data constant
const winnersData = {
    Winners: {
        TheChampion: [
            {
                Award: "The Champion",
                TeamName: "Drishti",
                UseCaseTitle:
                    "AI powered Hole Cleaning Monitoring System using Physics-based and Computer Visions models",
                UseCaseID: "U1UCI345",
                members: [
                    { name: 'Bala Saidulu Nallagondla' },
                    { name: 'Santosh Kumar Gupta' },
                    { name: 'Murugeshan M K' },
                    { name: 'Srinivasan J' },
                    { name: 'Rajjan Singh Thakur' },
                    { name: 'Raghu Ottoor Menon' },
                    { name: 'Janeshwar Prasad' },
                    { name: 'Mathialagan P' },
                    { name: 'Ramu Pedumajji' },
                ],
            }
        ],
        SpecialJuryAward: [
            {
                Award: "Special Jury Award",
                TeamName: "Drishtant",
                UseCaseTitle:
                    "Implementing Agentic AI in Reservoir Management of Enhanced Oil Recovery (EOR) process to Optimize Production from Mature Fields",
                UseCaseID: "U1UCI115",
                members: [
                    { name: 'Gaurav Mishra' },
                    { name: 'Rakesh Meena' },
                    { name: 'Nabajit Baruah' },
                    { name: 'Yogesh Mohan' },
                    { name: 'Nikhil Srivastava' },
                    { name: 'Anshul Jha' },
                    { name: 'Arpit Buddhiwant' },
                    { name: 'Jayant Boddu' },
                ],
            },
            {
                Award: "Special Jury Award",
                TeamName: "Well AI",
                UseCaseTitle:
                    "AI enabled Onshore Exploratory Well Cost Planning and its Variance Analysis",
                UseCaseID: "U1UCI392",
                members: [
                    { name: 'Veral Agarwal' },
                    { name: 'Shailendra Kumar' },
                    { name: 'Jatindra Kumar Samal' },
                    { name: 'Jitendra Kumar' },
                ],
            }
        ],
        FirstRunnersUp: [
            {
                Award: "First Runners-Up",
                TeamName: "Optiinject",
                UseCaseTitle: "Water Injection Optimization on oil reservoirs",
                UseCaseID: "U1UCI512",
                members: [
                    { name: 'Aninda Ghosh' },
                    { name: 'Anil Thapliyal' },
                    { name: 'A Rangaswamy' },
                    { name: 'Rakesh Meena' },
                    { name: 'Naveen M' },
                    { name: 'Pratik Ramesh Kumawat' },
                ],
            },
            {
                Award: "First Runners-Up",
                TeamName: "GeoPulse",
                UseCaseTitle:
                    "Full Waveform Inversion (FWI) for Advanced Seismic Model Building",
                UseCaseID: "U1UCI013",
                members: [
                    { name: 'Smitha N C' },
                    { name: 'Parimal Pritosh' },
                    { name: 'Sanjai Kumar Singh' },
                    { name: 'Manjula Singamsetty' },
                    { name: 'Mandeep Singh' },
                    { name: 'Mohammad Wasif Ansari' },
                    { name: 'Maduboyina Sudhakar' },
                ],
            },
            {
                Award: "First Runners-Up",
                TeamName: "Wisdom",
                UseCaseTitle: "Well intervention opportunity generation using AI",
                UseCaseID: "U1UCI295_322",
                members: [
                    { name: 'Dherendra Kumar Panday' },
                    { name: 'Sanjoy Das' },
                    { name: 'Mayank Kumar' },
                    { name: 'Neeraj Doneria' },
                    { name: 'Pradeep Kumar' },
                    { name: 'Pramod Azad' },
                    { name: 'Sujit Kumar Biswas' },
                    { name: 'Anita Kumari' },
                    { name: 'Shubham Gupta' },
                    { name: 'Swati' },
                ],
            }
        ],
        SecondRunnersUp: [
            {
                Award: "Second Runners-Up",
                TeamName: "Payzone AI",
                UseCaseTitle: "Missed Zone Identification",
                UseCaseID: "U1UCI255_257_390",
                members: [
                    { name: 'Abhishek Kumar' },
                    { name: 'Jitendra Bisoi' },
                    { name: 'Nitesh Kumar Jain' },
                    { name: 'Hitisha Dadlani' },
                    { name: 'Parth Chauhan' },
                    { name: 'Mahesh Pareek' },
                    { name: 'Dhiraj Singh' },
                    { name: 'Atul Kumar Pandey' },
                ],
            },
            {
                Award: "Second Runners-Up",
                TeamName: "Inv_Optima",
                UseCaseTitle: "Real time Inventory Forecasting",
                UseCaseID: "U1UCI447B",
                members: [
                    { name: 'Tiju Joy' },
                    { name: 'Shameer K' },
                    { name: 'Muhammed Kamil' },
                    { name: 'Rahul M S' },
                    { name: 'Onsuya Buragohain' },
                ],
            },
            {
                Award: "Second Runners-Up",
                TeamName: "WellStim Wizard",
                UseCaseTitle:
                    "Enhancing hydrocarbon recovery through AI powered stimulation job analysis",
                UseCaseID: "U1UCI287",
                members: [
                    { name: 'Dip Narayan Singh' },
                    { name: 'Sugata Guchhait' },
                    { name: 'Mahadev D Kaulaskar' },
                    { name: 'Girish Kumar' },
                    { name: 'Nirmal Kumar Mishra' },
                    { name: 'Yogesh Singh' },
                    { name: 'Amit Mishra' },
                    { name: 'Praveen Kumar Jha' }
                ],
            }
        ],
    },
  CategoryAwards: [
        {
            Award: "Smart Engineering",
            TeamName: "MargDarsh",
            UseCaseTitle: "AI Assisted Drill Bit Grading and Evaluation",
            UseCaseID: "U1UCI263",
            members: [
                { name: 'Bala Saidulu Nallagondla' },
                { name: 'Santosh Kumar Gupta' },
                { name: 'Rajjan Singh Thakur' },
                { name: 'Ramu Pedumajji' },
                { name: 'Manohar Kumar Kasi' },
                { name: 'Raghu Ottoor Menon' },
                { name: 'Srinivasan J' },
                { name: 'Bikash Acharya' },
            ],
        },
        {
            Award: "Paradigm Breaker",
            TeamName: "Lithomind",
            UseCaseTitle: "Facies Characterization by Machine Learning Techniques",
            UseCaseID: "U1UCI044",
            members: [
                { name: 'Satyajit Mondal' },
                { name: 'Sanjai Kumar Singh' },
                { name: 'Bhaskar Acharya' },
                { name: 'Jayendra Nath Chakraborty' },
                { name: 'Mohsin Dar' },
            ],
        },
        {
            Award: "Insight to Impact",
            TeamName: "Crew Path Innovators",
            UseCaseTitle: "Air Travel Cost Optimisation",
            UseCaseID: "U1UCI196",
            members: [
                { name: 'Harish N' },
                { name: 'Vishal Mittal' },
                { name: 'Jagpreet Singh' },
                { name: 'Kishore Dola' },
                { name: 'Vineet Arora' },
                { name: 'Anhishek sharma' },
            ],
        },
        {
            Award: "AI Adoption Trailblazer",
            TeamName: "WellEx",
            UseCaseTitle: "AI/ML Based Candidate Well Selection for Well Intervention",
            UseCaseID: "U1UCI077",
            members: [
                { name: 'Kaushal Agrawala' },
                { name: 'Sohil Shah' },
                { name: 'Alok Verma' },
            ],
        },
        {
            Award: "Digital Transformation Starter",
            TeamName: "Digi Fluids",
            UseCaseTitle: "Smart Drilling Fluid Management using AI and Digital Techniques",
            UseCaseID: "U1UCI366",
            members: [
                { name: 'Bala Saidulu Nallagondla' },
                { name: 'Santosh Kumar Gupta' },
                { name: 'Murugeshan M K' },
                { name: 'Srinivasan J' },
                { name: 'Rajjan Singh Thakur' },
                { name: 'Raghu Ottoor Menon' },
                { name: 'Janeshwar Prasad' },
                { name: 'Mathialagan P' },
                { name: 'Ramu Pedumajji' },
            ],
        },
        {
            Award: "Operational Impact",
            TeamName: "Nirantar",
            UseCaseTitle: "Tanker loading/ Unloading App",
            UseCaseID: "U1UCI010_151",
            members: [
                { name: 'Bhavesh Parmar' },
                { name: 'Tejpreet SIngh' },
            ],
        },
        {
            Award: "Smart Infrastructure",
            TeamName: "Predictive Pulse",
            UseCaseTitle: "Predictive Maintenance of Mud Pumps",
            UseCaseID: "U1UCI458",
            members: [
                { name: 'Mohammad Farhan' },
                { name: 'Ashish Sharma' },
                { name: 'Manoj Kumar Agnihotri' },
                { name: 'Mukul Gogoi' },
                { name: 'Anurag Verma' },
                { name: 'Rupesh Singh' },
            ],
        },
        {
            Award: "Strategic Transformation",
            TeamName: "Wadu AI",
            UseCaseTitle: "Optimization and Anomaly Detection of Surface Gas Network",
            UseCaseID: "U1UCI236",
            members: [
                { name: 'Bhartendu Bhardwaj' },
                { name: 'Neeraj Kumar' },
                { name: 'Chaitanya Bhatt' },
                { name: 'Bhargab Goswami' },
                { name: 'Randheer S Meena' },
            ],
        },
        {
            Award: "AI Foundation Builder",
            TeamName: "ProfitPro AI",
            UseCaseTitle: "Preparation of Estimated Profitability of the company for MIS and Advance Tax",
            UseCaseID: "U1UCI351",
            members: [
                { name: 'Veral Agarwal' },
                { name: 'Shailendra Kumar' },
                { name: 'Anil Singh Chauhan' },
            ],
        },
        {
            Award: "Ground Truth Innovator",
            TeamName: "Inv_Optima A",
            UseCaseTitle: "SAP Inventory Optimization: Deduplication & Consolidation",
            UseCaseID: "U1UCI447A",
            members: [
                { name: 'Tiju Joy' },
                { name: 'Shameer K' },
                { name: 'Muhammed Kamil' },
                { name: 'Rahul M S' },
                { name: 'Onsuya Buragohain' },
            ],
        },
        {
            Award: "AI Technology",
            TeamName: "Pravaah_AI",
            UseCaseTitle: "Smartlift",
            UseCaseID: "U1UCI359",
            members: [
                { name: 'Ritesh Parashar' },
                { name: 'Akhil Jain' },
                { name: 'Mayank Kumar' },
            ],
        }
    ]
};

/* FINAL AWARD ITEMS */ const finalAwardItems = [
  { title: "Innovation Book Set", image: "/images/book.jpg" },
  { title: "Excellence Medal", image: "/images/medal.jpg" },
  { title: "Framed Certificate", image: "/images/certificate.jpg" },
{ title: "Winner Shields", image: "/images/awards.jpg" },
{ title: "Finalist Trophy", image: "/images/winnertrophy.jpg" },

];

// Responsive Hook
const useIsMobile = (breakpoint = 600) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth <= breakpoint);
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, [breakpoint]);

  return isMobile;
};

const styles = {
  hierarchy: {
    display: "flex",
    flexDirection: "column",
    gap: "3rem",
    width: "100%",
    alignItems: "center",
  },
  level: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "24px",
    width: "100%",
    padding: "1rem",
  },
  cardBorder: {
    content: '""',
    position: "absolute",
    top: "12px",
    left: "12px",
    right: "12px",
    bottom: "12px",
    border: "2px dashed #06d6a0",
    borderRadius: "15px",
    pointerEvents: "none",
  },
  winnerTitle: {
    fontSize: "2rem",
    fontWeight: 700,
    background: "linear-gradient(90deg, #e63946, #06d6a0)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "1rem",
    textTransform: "uppercase",
  },
  winnerTeam: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#ffffff",
    marginBottom: "0.8rem",
  },
  winnerUsecase: {
    fontSize: "1.05rem",
    color: "#cccccc",
    lineHeight: 1.6,
    marginBottom: "1.2rem",
  },
  winnerId: {
    fontSize: "0.95rem",
    color: "#999999",
    fontStyle: "italic",
  },
};

const AwardCard = ({ Award, TeamName, UseCaseTitle, UseCaseID, members, isMobile }) => {
  const [showMembers, setShowMembers] = useState(false);

  return (
    <div style={{
      background: "#101820",
      border: "3px solid #e63946",
      borderRadius: "20px",
      padding: isMobile ? "1.2rem" : "2rem",
      width: isMobile ? "90%" : "360px",
      minHeight: "auto",
      boxShadow: "0 0 25px rgba(230, 57, 70, 0.4), 0 0 50px rgba(0, 255, 128, 0.2)",
      textAlign: "center",
      position: "relative",
      transition: "transform 0.25s ease, box-shadow 0.3s ease",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 auto",
    }}>
      <div style={styles.cardBorder}></div>
      <div>
        {!showMembers ? (
          <>
            <h3 style={styles.winnerTitle}>{Award}</h3>
            <p style={styles.winnerTeam}>{TeamName}</p>
            <p style={styles.winnerUsecase}>{UseCaseTitle}</p>
            {UseCaseID && <p style={styles.winnerId}>{UseCaseID}</p>}
            {members && members.length > 0 && (
              <div onClick={() => setShowMembers(true)} style={{
                marginTop: "1.5rem",
                cursor: "pointer",
                display: "inline-block",
                backgroundColor: "#c5cfcc",
                color: "#000",
                padding: "0.6rem 1.2rem",
                borderRadius: "20px",
                fontWeight: "bold",
                transition: "all 0.3s ease",
                fontSize: "0.9rem"
              }} onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                 onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
              >
               View Team Members
              </div>
            )}
          </>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <span style={{ fontSize: '1.3rem', fontWeight: 'bold', color: '#fff' }}>Team Members</span>
              <span onClick={() => setShowMembers(false)} style={{ fontSize: '2rem', cursor: 'pointer', color: '#e63946', fontWeight: 'bold' }}>
                &times;
              </span>
            </div>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "0.8rem",
            }}>
              {members.map((member, index) => (
                <div key={index} style={{
                  backgroundColor: "#2a3f4d",
                  color: "#fff",
                  padding: "0.7rem 1rem",
                  borderRadius: "25px",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  textAlign: "center",
                  border: "1px solid rgba(6, 214, 160, 0.3)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#3a4f5d";
                  e.currentTarget.style.boxShadow = "0 0 15px rgba(230, 57, 70, 0.3)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                  onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#2a3f4d";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                }}>
                  {member.name}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const FinalAwards = () => {
  const isMobile = useIsMobile();
  const angle = 360 / (finalAwardItems.length || 1);

  return (
    <section
      style={{ 
        minHeight: "100vh", 
        lineHeight: 1.4,
        background: "#000",
        color: "#fff",
        padding: isMobile ? "2rem 1.5rem" : "4rem 2.5rem 6rem",
        overflowX: "hidden" // Prevents 3D elements from causing horizontal scroll on mobile
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: isMobile ? "flex" : "grid",
          flexDirection: isMobile ? "column" : "unset", // Stack vertically on mobile
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1.2fr",
          gap: isMobile ? "1rem" : "3rem",
          marginBottom: isMobile ? "2rem" : "5rem",
        }}
      >
        {/* LEFT CONTENT */}
        <div className="max-w-7xl mx-auto">
          <h2
            className="text-2xl md:text-3xl font-bold
                       mt-6 mb-6
                       bg-gradient-to-r from-green-400 via-red-500 to-green-500
                       bg-clip-text text-transparent
                       leading-snug"
          >
            Ideas that went the distance
          </h2>

          <div className="h-1 w-24 bg-gradient-to-r from-green-400 to-red-500 mb-6" />

          <p className="text-white text-[1.1rem] leading-[1.7] mb-6">
            The Final Awards honoured ideas that moved beyond intent and imagination into execution.{" "}
            <span className="text-white font-semibold">
              The teams demonstrated the ability to sharpen their thinking and adapt through feedback.
            </span>
          </p>

          <p className="text-white text-[1.1rem] leading-[1.7]">
            These efforts steadily translated concepts into credible, working solutions,{" "}
            <span className="text-white font-semibold">
              demonstrating focus, resilience, and real-world impact.
            </span>
          </p>
        </div>

        {/* RIGHT GIFTS / CERTIFICATE ROTATOR */}
        <div style={{ marginTop: isMobile ? "2rem" : "-2.5rem" }}> 
          <div className="flex justify-center mb-10">
            <div
              className="perspective-container"
              style={{ 
                width: isMobile ? "100%" : "670px", 
                height: isMobile ? "280px" : "420px",
                maxWidth: isMobile ? "320px" : "670px"
              }}
            >
              <div className="carousel-3d">
                {finalAwardItems.map((cert, index) => (
                  <div
                    key={index}
                    className="carousel-item"
                    style={{
                      "--i": index,
                      "--angle": `${angle}deg`,
                      width: isMobile ? "200px" : "360px",
                      transform: `translate(-50%, -50%) rotateY(${index * angle}deg) translateZ(${isMobile ? "140px" : "260px"})`
                    }}
                  >
                    <div className="certificate-card" style={{ height: isMobile ? "140px" : "260px" }}>
                      <img
                        src={cert.image}
                        alt={`${cert.title} Certificate`}
                        className="certificate-image"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>

                    <p className="category mt-2" style={{ color: "#fff", fontSize: isMobile ? "0.6rem" : "0.75rem" }}>
                      {cert.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= AWARD DISTRIBUTION SECTION ================= */}
      <div style={{ maxWidth: "1200px", margin: "2rem auto 4rem" }}>
        <h3
          className="text-2xl md:text-3xl font-bold text-center mb-6
                     bg-gradient-to-r from-green-400 via-red-500 to-green-500
                     bg-clip-text text-transparent animate-gradient
                     leading-snug md:leading-snug lg:leading-snug"
        >
          Award Distribution to Winners and Finalists
        </h3>
        <div
          style={{
            overflow: "hidden",
            position: "relative",
            width: "100%",
            padding: "1rem 0",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "2rem",
              animation: "scroll 20s linear infinite",
            }}
          >
            {awardDistributionImages.map((item, index) => (
              <div
                key={index}
                style={{
                  minWidth: isMobile ? "260px" : "340px",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
                  transition: "transform 0.3s ease",
                  background: "#111"
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-6px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  style={{ width: "100%", height: "220px", objectFit: "cover" }}
                />
                <div style={{ padding: "1rem", textAlign: "center" }}>
                  <p style={{ color: "#fff", fontSize: "0.95rem", fontWeight: "600", lineHeight: 1.4 }}>
                    {item.title}
                  </p>
                </div>
              </div>
            ))}

            {/* Duplicate for seamless scroll */}
            {awardDistributionImages.map((item, index) => (
              <div
                key={"dup-" + index}
                style={{
                  minWidth: isMobile ? "260px" : "340px",
                  borderRadius: "16px",
                  overflow: "hidden",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.6)",
                  transition: "transform 0.3s ease",
                  background: "#111"
                }}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  style={{ width: "100%", height: "220px", objectFit: "cover" }}
                />
                <div style={{ padding: "1rem", textAlign: "center" }}>
                  <p style={{ color: "#fff", fontSize: "0.95rem", fontWeight: "600", lineHeight: 1.4 }}>
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <style>
            {`
              @keyframes scroll {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
            `}
          </style>
        </div>
      </div>

      {/* WINNERS HEADING */}
      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <h3 style={{
          fontSize: isMobile ? "1.75rem" : "2.25rem",
          fontWeight: "bold",
          marginTop: "0.25rem",
          marginBottom: "1rem",
          background: "linear-gradient(to right, #22c55e, #ef4444, #22c55e)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}>
          Udbhav 2025 Winners
        </h3>
      </div>

      {/* WINNERS LIST */}
      <div style={styles.hierarchy}>
        {winnersData.Winners &&
          Object.entries(winnersData.Winners).map(([category, winners], catIndex) => (
            <div key={`cat-${catIndex}`} style={{ width: "100%", marginBottom: "3rem" }}>
              <h4
                style={{
                  textAlign: "center",
                  color: "#06d6a0",
                  marginBottom: "2rem",
                  fontSize: isMobile ? "1rem" : "1.3rem",
                }}
              >
                {category === "TheChampion" && " The Champion"}
                {category === "SpecialJuryAward" && " Special Jury Award"}
                {category === "FirstRunnersUp" && " First Runners-Up"}
                {category === "SecondRunnersUp" && " Second Runners-Up"}
              </h4>
              <div style={styles.level}>
                {winners.map((item, index) => (
                  <AwardCard key={`winner-${category}-${index}`} {...item} isMobile={isMobile} />
                ))}
              </div>
            </div>
          ))}

        {/* CATEGORY AWARDS */}
        {winnersData.CategoryAwards && (
          <div style={{ width: "100%", marginBottom: "3rem" }}>
            <h4
              style={{
                textAlign: "center",
                color: "#06d6a0",
                marginBottom: "2rem",
                fontSize: isMobile ? "1rem" : "1.3rem",
              }}
            >
              Category Awards
            </h4>
            <div style={styles.level}>
              {winnersData.CategoryAwards.map((item, index) => (
                <AwardCard key={`category-${index}`} {...item} isMobile={isMobile} />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* 3D ROTATOR STYLES */}
      <style>{`
        .perspective-container {
          perspective: 1200px;
          width: 480px;
          height: 300px;
          margin: 0 auto;
        }

        .carousel-3d {
          position: relative;
          width: 100%;
          height: 100%;
          transform-style: preserve-3d;
          animation: rotate3d 26s linear infinite;
          will-change: transform;
        }

        .perspective-container:hover .carousel-3d {
          animation-play-state: paused;
        }

        @keyframes rotate3d {
          from { transform: rotateY(0deg); }
          to { transform: rotateY(360deg); }
        }

        .carousel-item {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 280px;
          text-align: center;
        }

        .certificate-card {
          width: 100%;
          height: 220px;
          background: #111;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 20px 50px rgba(0,0,0,0.6);
          transition: transform 0.35s ease, box-shadow 0.35s ease;
        }

        .carousel-item:hover .certificate-card {
          transform: scale(1.05);
        }

        .certificate-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .category {
          font-size: 0.75rem;
          letter-spacing: 2px;
          color: #22c55e;
          font-weight: 600;
        }

        /* MOBILE OVERRIDES */
        @media (max-width: 640px) {
          .perspective-container {
            width: 100%;
            height: 260px;
          }

          .carousel-item {
            width: 200px;
            /* Injected via style prop for translateZ responsiveness */
          }

          .certificate-card {
            height: 140px;
          }
        }
      `}</style>
    </section>
  );
};

export default FinalAwards;